export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-job-Cancel.html',
            attributes: { 'data-id': 'sm-job-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-job-Cancel-d66e713',
            topics: [],
        },
        {
            title: ' CheckIfJobInProcess ',
            href: 'sm-job-CheckIfJobInProcess.html',
            attributes: { 'data-id': 'sm-job-CheckIfJobInProcess' },
            menu: { hasChildren: false },
            tocID: 'sm-job-CheckIfJobInProcess-d66e721',
            topics: [],
        },
        {
            title: ' Execute ',
            href: 'sm-job-Execute.html',
            attributes: { 'data-id': 'sm-job-Execute' },
            menu: { hasChildren: false },
            tocID: 'sm-job-Execute-d66e729',
            topics: [],
        },
        {
            title: ' FilesExist ',
            href: 'sm-job-FilesExist.html',
            attributes: { 'data-id': 'sm-job-FilesExist' },
            menu: { hasChildren: false },
            tocID: 'sm-job-FilesExist-d66e737',
            topics: [],
        },
        {
            title: ' GetJobsInProcess ',
            href: 'sm-job-GetJobsInProcess.html',
            attributes: { 'data-id': 'sm-job-GetJobsInProcess' },
            menu: { hasChildren: false },
            tocID: 'sm-job-GetJobsInProcess-d66e745',
            topics: [],
        },
        {
            title: ' GetStatus ',
            href: 'sm-job-GetStatus.html',
            attributes: { 'data-id': 'sm-job-GetStatus' },
            menu: { hasChildren: false },
            tocID: 'sm-job-GetStatus-d66e753',
            topics: [],
        },
        {
            title: ' HasWarning ',
            href: 'sm-job-HasWarning.html',
            attributes: { 'data-id': 'sm-job-HasWarning' },
            menu: { hasChildren: false },
            tocID: 'sm-job-HasWarning-d66e761',
            topics: [],
        },
        {
            title: ' Pause ',
            href: 'sm-job-Pause.html',
            attributes: { 'data-id': 'sm-job-Pause' },
            menu: { hasChildren: false },
            tocID: 'sm-job-Pause-d66e769',
            topics: [],
        },
        {
            title: ' Submit ',
            href: 'sm-job-Submit.html',
            attributes: { 'data-id': 'sm-job-Submit' },
            menu: { hasChildren: false },
            tocID: 'sm-job-Submit-d66e777',
            topics: [],
        },
        {
            title: ' SubmitFromModel ',
            href: 'sm-job-SubmitFromModel.html',
            attributes: { 'data-id': 'sm-job-SubmitFromModel' },
            menu: { hasChildren: false },
            tocID: 'sm-job-SubmitFromModel-d66e785',
            topics: [],
        },
        {
            title: ' SubmitSoapCall ',
            href: 'sm-job-SubmitSoapCall.html',
            attributes: { 'data-id': 'sm-job-SubmitSoapCall' },
            menu: { hasChildren: false },
            tocID: 'sm-job-SubmitSoapCall-d66e794',
            topics: [],
        },
        {
            title: ' WaitJobCancelled ',
            href: 'sm-job-WaitJobCancelled.html',
            attributes: { 'data-id': 'sm-job-WaitJobCancelled' },
            menu: { hasChildren: false },
            tocID: 'sm-job-WaitJobCancelled-d66e802',
            topics: [],
        },
    ],
};

